/**
 * @generated SignedSource<<d8c62ba80629cccc390752c81172d32c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type MeetingPhaseContext_viewer$data = {
  readonly account: {
    readonly allowMeetingRecording: boolean;
  };
  readonly hasAccessToCopilot: boolean;
  readonly hasAccessToScheduledMeetingRecordings: boolean;
  readonly hasAdminAccess: boolean;
  readonly meetingRecapAutoShareSettings: {
    readonly id: string;
    readonly sendTo: UserMeetingRecapSendTo;
  } | null;
  readonly remainingMeetingRecordingCredits: number;
  readonly user: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"featureFlag_useCopilotPaywallsOn_viewer">;
  readonly " $fragmentType": "MeetingPhaseContext_viewer";
};
export type MeetingPhaseContext_viewer$key = {
  readonly " $data"?: MeetingPhaseContext_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingPhaseContext_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingPhaseContext_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "featureFlag_useCopilotPaywallsOn_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToScheduledMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAdminAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMeetingRecording",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMeetingRecapAutoShareSettings",
      "kind": "LinkedField",
      "name": "meetingRecapAutoShareSettings",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendTo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a97817b76745ce4d96e996b1c1a1df3d";

export default node;
